import { Sparkles } from 'lucide-react'

export default function Placeholder({ title }) {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-heading font-bold text-gray-900">{title}</h1>
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-10 flex flex-col items-center justify-center text-center">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-100 to-accent-100 flex items-center justify-center mb-3">
          <Sparkles size={26} className="text-accent-600" />
        </div>
        <p className="font-medium text-gray-700">{title}</p>
        <p className="text-sm text-gray-400 mt-1">Em breve.</p>
      </div>
    </div>
  )
}
